<template lang="pug">
.cp-about
  .banner
    p.p1 关爱触手可及
    p.p2 CARE YOU CAN TOUCH
    p.p3 让机器人进入千家万户，成为服务机器人行业的领先企业
  #company-profile.w
    h2 公司简介
    h3 Company profile
    h4 智能服务机器人研发及产业化领先企业
    p 弗徕威智能机器人科技（上海）有限公司是国内率先参与制订服务机器人企业标准、并获得首批认证的企业。2012年8月注册于上海浦东，是国家高新技术企业、科技部创新基金支持单位、国家战略新兴产业标准化试点单位、科技部《养老服务课题》承接单位、国家知识产权局“专利试点单位”、上海市“专精特新”企业、浦东新区科委重点科技创业企业以及国家三部委（工信部、民政部、卫健委）授予智慧健康养老应用试点示范企业。作为主要参编单位、企业参与了4个机器人国家标准和4个行业标准制定。
    p 企业专注于服务机器人领域深耕十年，是全球领先的以智能机器人为核心技术的智慧社区解决方案供应商，拥有完整自主知识产权体系且可自主生产服务机器人。企业是国内最早实现机器人量产、且一次性交付量最大的服务机器人之一，技术实现力和产品稳定性已获市场验证。团队核心成员主要来自机器人领域具有国际和国内影响力的专家，已授权核心发明专利数量行业领先。企业已形成机器人智慧社区、智慧康养、智能清洁等多场景解决方案，且在多个地产项目和康养机构示范应用落地。科技赋能，共创美好生活。

    img.img(v-if="isMobile", src="../assets/mobile/about-citys.jpg")
    img.img(v-else, src="../assets/web/about-citys.jpg")
  #application-area.w
    h2 应用领域
    h3 Application Area
    ul.list
      li
        img(src="../assets/web/about-img1.png")
        .title 智慧社区
        p 
          |提供以机器人为核心的
          br
          |整套智慧住宅解决方案
      li
        img(src="../assets/web/about-img2.png")
        .title 智慧康养
        p
          |提供专业的长者居家照护和陪伴服务机器人
          br
          |打造机器人智慧康养社区
      li
        img(src="../assets/web/about-img3.png")
        .title 智慧清洁
        p
          |提供公共空间无人驾驶智能清洁、
          br
          |消杀毒服务机器人解决方案
  #contact-us
    .w
      h2 联系我们
      h3 Contact us
      .info1
        .left
          h4 联系方式
          p 地址：上海·长宁·威宁路369号缤谷大厦10楼1001室
          p 地址：上海·浦东·芳春路400号1幢3层
          p 总机：193 0215 5869
          p 邮箱：marketing@flyingwings.cn
      .info2
        .item
          h4 业务合作
          p 电话：193 0215 5869
        .item
          h4 供应商合作
          p 电话：193 0215 5869
        .item
          h4 售后服务
          p 电话：193 0215 5869
        .item
          h4 媒体合作
          p
            |邮箱：
            a(href="mailto:jj.li@flyingwings.cn") marketing@flyingwings.cn
        .item
          h4 产品反馈
          p
            |邮箱：
            a(href="mailto:feedback@flyingwing.cn") feedback@flyingwing.cn
        .item
          h4 加入我们
          p
            |邮箱：
            a(href="mailto:hr@flyingwings.cn") hr@flyingwings.cn
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style lang="stylus">
@import 'config'
.cp-about
  color #333
  h2
    font-size 30px
    text-align center
  h3
    font-size 16px
    text-align center
  .banner
    background url(../assets/web/banner-about.jpg) center
    background-size auto 100%
    width 100%
    height 550px
    color #fff
    font-size 18px
    display flex
    justify-content center
    align-items center
    flex-direction column
    .p1
      font-size 40px
    .p2
      margin 0 0 20px 0
  #company-profile
    padding-top 60px
    h4
      font-size 16px
      text-align center
      padding-top 20px
    p
      padding 20px 60px 0
      text-indent 2em
      font-size 14px
    .img
      display block
      margin 40px auto 0
  #application-area
    padding 60px 0 100px
    ul
      margin-top 40px
      text-align center
      li
        display inline-block
        width 240px
        margin 0 80px
        .title
          font-size 18px
          margin 20px 0
        p
          font-size 13px
          width 250px
  #contact-us
    background #f5f7f9
    padding 40px 0 30px
    .info1
      margin-top 40px
      height 390px
      background #fff
      background url(../assets/web/map.png) right center no-repeat #fff
      .left
        font-size 18px
        width 440px
        padding 50px 0 0 110px
        h4
          text-align center
          padding-bottom 10px
          margin-bottom 56px
          background url(../assets/web/bd1.png) bottom center no-repeat
        p
          line-height 40px
    .info2
      background-color #fff
      margin-top 15px
      overflow hidden
      padding-left 110px
      padding-bottom 35px
      .item
        float left
        width 360px
        padding-top 35px
        h4
          font-size 18px
          padding-bottom 10px
        p
          font-size 14px
.is-mobile
  .cp-about
    h2
      font-size r(30)
    h3
      font-size r(20)
    .banner
      height r(1111)
      background-image url(../assets/mobile/banner-about.jpg)
      .p1
        margin-top r(-500)
        font-size r(40)
      .p2
        font-size r(18)
      .p3
        font-size r(20)
    #company-profile
      padding-top r(30)
      h2
        font-size r(30)
      h3
        font-size r(20)
      p
        padding r(20) r(60) 0
        line-height 1.8
      .img
        margin r(40) auto 0
        width 90%
    #application-area
      padding r(60) 0
      ul
        li
          display block
          margin 0 auto r(40)
          img
            width r(240)
          .title
            font-size r(18)
            margin r(20) 0
          p
            font-size r(13)
    #contact-us
      padding r(40) 0
      .info1
        margin r(40)
        height r(760)
        background url(../assets/mobile/map.jpg) right bottom no-repeat #fff
        background-size 100% auto
        .left
          width 100%
          padding 0
          h4
            padding r(20) 0
            margin-bottom r(35)
          p
            line-height 2
            font-size r(28)
            padding-left r(80)
      .info2
        margin 0
        padding 0
        .item
          width 50%
          padding r(30) 0 r(30) r(30)
          h4
            font-size r(28)
          p
            font-size r(22)
</style>



// WEBPACK FOOTER //
// src/views/about.vue